import type { SnakeCasedPropertiesDeep } from 'type-fest';
import { convertKeysToCase } from './keys-string-case-conversion';

export const toSnakeCase = (camelCaseString: string | number = ''): string => {
  const words = camelCaseString.toString().match(/([A-Z][a-z]+)|(\d+)|([a-z]+)|([A-Z]+)/g) || [
    camelCaseString,
  ];
  return words.join('_').toLowerCase();
};

export const keysToSnakeCase = <T>(obj: T, deep = false): SnakeCasedPropertiesDeep<T> =>
  convertKeysToCase<T, SnakeCasedPropertiesDeep<T>>({ obj, convertFn: toSnakeCase, deep });
